import { useQuery } from '@tanstack/react-query';
import type { AgentApiCompanyTagsIndex } from '@/types/serializers';

export default function useCompanyTagsList() {
  return useQuery({
    queryKey: ['/agent/api/company_tags'],
    queryFn: async () => {
      const response = await fetch('/agent/api/company_tags.json');
      const data: AgentApiCompanyTagsIndex = await response.json();
      return {
        tags: data.records.map(({ id, name, color_hex }) => ({ id, name, colorHex: color_hex })),
      };
    },
  });
}
